import Screen from './screen.js'
const $ = jQuery

/**
 * Initialize slick.js sliders inside Bootstrap modals
 *
 * @param {Event} event - The Bootstrap modal show event
 */
export const initializeGallerySlider = function (event) {
    const $modal = $(event.currentTarget)

    $modal.find('.gallery').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: `#${$modal.attr('id')} .gallery-controls`,
        adaptiveHeight: true,
        draggable: false,
        useTransform: false,
        responsive: [
            {
                breakpoint: Screen.breakpoints.sm,
                settings: {
                    draggable: true,
                    dots: true,
                },
            },
        ],
    })

    $modal.find('.gallery-controls').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: `#${$modal.attr('id')} .gallery`,
        dots: true,
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        useTransform: false,
        responsive: [
            {
                breakpoint: Screen.breakpoints.sm,
                settings: 'unslick',
            },
        ],
    })
}

export const handleRefreshModal = function (modal) {
    const $modal = $(modal)
    const $gallery = $modal.find('.gallery')
    const $galleryControls = $modal.find('.gallery-controls')

    $gallery.on('setPosition', (event, slick) => {
        if (slick.$list.height() === 0 || slick.$slideTrack.width() === 0) {
            $modal.one('shown.bs.modal', function () {
                $gallery.slick('refresh')
                $galleryControls.slick('refresh')
            })
        }
    })
}

export const handleRefreshAccordion = function (accordion) {
    const $accordion = $(accordion)
    const $gallery = $accordion.find('.gallery')

    $gallery.on('setPosition', (event, slick) => {
        if (slick.$list.height() === 0 || slick.$slideTrack.width() === 0) {
            $accordion.one('shown.bs.collapse', function () {
                $gallery.slick('refresh')
            })
        }
    })
}
